import { FunctionComponent, useEffect, useState } from "react";
import { QrReader } from "./QrReader";
import { Spinner } from "./Spinner";
import classes from "./Scanner.module.scss";
import { listServers } from "./api";

export const Scanner: FunctionComponent<{ apiUrl: string }> = ({ apiUrl }) => {
  const [servers, setServers] = useState<Array<string> | undefined>(undefined);

  const [state, setState] = useState<{
    server: string;
    uid: string;
    input: string;
  }>({
    server: "",
    uid: "",
    input: "",
  });

  useEffect(() => {
    const abortController = new AbortController();

    listServers(apiUrl, abortController.signal)
      .then((servers) => {
        setServers(servers);

        if (servers && servers.length > 0) {
          setState({ server: servers[0], uid: "", input: "" });
        }
      })
      .catch((error) => console.error(error));

    return () => abortController.abort();
  }, [apiUrl]);

  return (
    <div className={classes.scanner}>
      <div className={classes.section}>
        <select
          value={state.server}
          onChange={(event) =>
            setState({ server: event.target.value, uid: "", input: "" })
          }
        >
          {servers?.map((server) => (
            <option key={server} value={server}>
              {server}
            </option>
          )) ?? (
            <option value="" disabled>
              select ROP-server
            </option>
          )}
        </select>

        {state.server && (
          <>
            <br />
            <input
              type="text"
              value={state.input}
              onChange={(event) =>
                setState({ ...state, uid: "", input: event.target.value })
              }
              onKeyUp={(event) => {
                if (event.key === "Enter") {
                  setState({ ...state, uid: state.input, input: "" });
                }
              }}
              placeholder="enter uid"
            />
            <div className={classes.text}>- or -</div>
            <QrReader
              onScanned={(value) =>
                setState({ ...state, uid: value, input: "" })
              }
            />
            {state.input && (
              <button
                className={classes.btn}
                onClick={() =>
                  setState({ ...state, uid: state.input, input: "" })
                }
              >
                Generate
              </button>
            )}
            {state.server && state.uid && (
              <div className={classes.spinner}>
                <img
                  className={classes["qr-code"]}
                  src={`${apiUrl}/device/${state.server}/${state.uid}/qr-code`}
                  alt="QR Code could not be loaded."
                />
                <Spinner />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
